import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import LocalStorageManager from './LocalStorageManager'
import Modal from '../../Common/Components/Modal'
import styled from 'styled-components'

const Info = styled.p`
  color: ${({ theme }) => theme.palette.contrastHigh.main};
  font-size: 14px;
  margin-bottom: 2rem;
`

const LocalStorageManagerModal = ({ onClose }) => {
  const { t } = useTranslation()
  return (
    <Modal title={t('common:ui.LocalStorageQuotaExceeded')} onClose={onClose} maxWidth={'md'}>
      <Info>{t('common:ui.LocalStorageQuotaExceededInfo')}</Info>
      <LocalStorageManager />
    </Modal>
  )
}

LocalStorageManagerModal.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default LocalStorageManagerModal
